// js
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AdoptionChartLegend from '../AdoptionChartLegend';
import AdoptionOverviewChart from './AdoptionOverviewChart';


class AdoptionOverviewPPTX extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      abilities,
      pptxTarget,
      getAdoptionGoalsByArea,
      getUserGroups
    } = this.props;

    const adoptionGoalsByArea = getAdoptionGoalsByArea(this.props);
    const userGroups = getUserGroups();

    const classNames = classnames({
      'analytics__adoption-overview-pptx': true,
      'analytics__adoption-overview-pptx--without-business-analytics-area': !abilities.canActivateBusinessAnalyticsArea
    });

    return (
      <div
        id={pptxTarget}
        className={classNames}
      >
        <AdoptionOverviewChart
          areas={adoptionGoalsByArea}
          groups={userGroups}
        />
        <AdoptionChartLegend />
      </div>
    );
  }
}

AdoptionOverviewPPTX.propTypes = {
  getAdoptionGoalsByArea: PropTypes.func.isRequired,
  getUserGroups: PropTypes.func.isRequired,
  pptxTarget: PropTypes.string,
  abilities: PropTypes.object.isRequired
};

export default AdoptionOverviewPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/AdoptionOverviewPPTX.js